export default () => '/accidents';
